function fixAccessibilityButtons() {
  const clearButton = document.querySelector('.gf-controls-clear-button');
  const searchButton = document.querySelector('.gf-controls-search-button');

  if (clearButton) {
    if (!clearButton.getAttribute('role')) {
      clearButton.setAttribute('role', 'button');
    }
    clearButton.setAttribute('aria-label', 'Clear search');
    if (!clearButton.getAttribute('tabindex')) {
      clearButton.setAttribute('tabindex', '0');
    }
  }

  if (searchButton) {
    if (!searchButton.getAttribute('role')) {
      searchButton.setAttribute('role', 'button');
    }
    // Always use English on English storefront pages
    searchButton.setAttribute('aria-label', 'Search products');
    if (!searchButton.getAttribute('tabindex')) {
      searchButton.setAttribute('tabindex', '0');
    }
  }
}

function injectSmartMenuKeyboardStyles() {
  if (document.getElementById('ci-smart-menu-a11y')) return;
  const style = document.createElement('style');
  style.id = 'ci-smart-menu-a11y';
  style.textContent = `
    @media (min-width: 990px) {
      /* Panels open for keyboard users only on Enter / Space / ArrowDown
         ([data-ci-kb-open]; an attribute because the app's Vue re-renders replace
         the class list), not merely because focus is inside the item.
         Mouse hover is still handled entirely by the app. */
      .tmenu_item--root[data-ci-kb-open] > .tmenu_submenu {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: auto !important;
      }

      /* Qikify only unhides nested mega lists when the root has
         .tmenu_item_active (hover); keep them visible while keyboard-open. */
      .tmenu_item--root.tmenu_item_submenu_type_mega[data-ci-kb-open] li.tmenu_item > .tmenu_submenu {
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: auto !important;
      }

      /* Tab-type submenus (HOME GOODS): the app makes every tab panel's content
         visible while the root is active, so links of the non-selected tabs
         (stacked under the selected one) stayed focusable but unseen. */
      .tmenu_item_submenu_type_tab .tmenu_submenu_tab_item:not(.tmenu_submenu_tab_active) .tmenu_submenu {
        visibility: hidden !important;
      }

      .tmenu_item--root.tmenu_item_submenu_type_mega .tmenu_masonry_placeholder,
      .tmenu_item--root.tmenu_item_submenu_type_mega .tmenu_masonry_placeholder li.tmenu_item > .tmenu_submenu,
      .tmenu_item--root.tmenu_item_submenu_type_mega .tmenu_masonry_placeholder .tmenu_submenu {
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    }

    /* Smart Menu adds its own "Skip to main content" link right after the
       theme's "Skip to content" (same #MainContent target): one is enough. */
    .tmenu_skip-link {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
}

function mouseOpts() {
  return { bubbles: true, cancelable: true, composed: true, view: window };
}

function isDesktopMenu() {
  return window.matchMedia('(min-width: 990px)').matches;
}

function smartMenuRootLink(item) {
  return item?.querySelector(':scope > a.tmenu_item_link') || null;
}

// Panels are rendered lazily by the app (only after first activation), so use the
// item's "has child" class rather than looking for the panel element.
function smartMenuHasPanel(item) {
  return !!item && (item.classList.contains('tmenu_item_has_child') || !!item.querySelector(':scope > .tmenu_submenu'));
}

function setSmartMenuExpanded(item, open) {
  if (!smartMenuHasPanel(item)) return;
  smartMenuRootLink(item)?.setAttribute('aria-expanded', open ? 'true' : 'false');
  item.querySelector(':scope > .tmenu_toggle')?.setAttribute('aria-expanded', open ? 'true' : 'false');
}

function closeSmartMenuKeyboard(exceptItem) {
  document.querySelectorAll('.tmenu_item--root[data-ci-kb-open]').forEach((item) => {
    if (item === exceptItem) return;
    item.removeAttribute('data-ci-kb-open');
    setSmartMenuExpanded(item, false);
    item.dispatchEvent(new MouseEvent('mouseleave', mouseOpts()));
    item.__vueParentComponent?.exposed?.deactive?.();
  });
}

function openSmartMenuKeyboardItem() {
  return document.querySelector('.tmenu_item--root[data-ci-kb-open]');
}

function vueSetupState(el) {
  const instance = el?.__vueParentComponent;
  return instance?.setupState || instance?.ctx || instance?.exposed || null;
}

function activateSmartMenuItem(item) {
  if (!item) return;
  const state = vueSetupState(item);
  if (typeof state?.active === 'function') {
    state.active();
    return;
  }
  item.dispatchEvent(new MouseEvent('mouseover', mouseOpts()));
  item.dispatchEvent(new MouseEvent('mouseenter', mouseOpts()));
}

function openSmartMenuRoot(item) {
  if (!item) return;
  closeSmartMenuKeyboard(item);
  item.setAttribute('data-ci-kb-open', '');
  setSmartMenuExpanded(item, true);
  activateSmartMenuItem(item);
}

function isKeyboardFocusable(el) {
  if (!el || el.tabIndex < 0 || el.closest('[aria-hidden="true"], [inert]')) return false;
  const style = window.getComputedStyle(el);
  if (style.visibility === 'hidden' || style.display === 'none') return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 1 && rect.height > 1;
}

// The app renders panel links lazily, so wait (up to ~1s) for the first visible one.
function focusFirstSmartMenuLink(item) {
  let tries = 0;
  const attempt = () => {
    const first = Array.from(item.querySelectorAll('.tmenu_submenu a[href], .tmenu_submenu button, .tmenu_submenu [tabindex]')).find(
      isKeyboardFocusable
    );
    if (first) {
      first.focus();
      return;
    }
    if (++tries < 20) window.setTimeout(attempt, 50);
  };
  window.setTimeout(attempt, 50);
}

function toggleSmartMenuFromKey(link, key) {
  const item = link.closest('.tmenu_item--root');
  if (!item || link.parentElement !== item || !smartMenuHasPanel(item)) return false;

  const isOpen = item.hasAttribute('data-ci-kb-open');
  if (isOpen && key !== 'ArrowDown') {
    closeSmartMenuKeyboard();
    link.focus();
    return true;
  }

  if (!isOpen) openSmartMenuRoot(item);
  focusFirstSmartMenuLink(item);
  return true;
}

function onSmartMenuFocusIn(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (!isDesktopMenu()) return;

  const open = openSmartMenuKeyboardItem();
  const root = target.closest('.tmenu_item--root');

  // Focus moved to another top-level item (Tab past the last link of an open
  // panel, or Tab from a closed item): close the open panel. Nothing opens on focus.
  if (open && root !== open) closeSmartMenuKeyboard();
  if (!root || !root.hasAttribute('data-ci-kb-open')) return;

  const tabLink = target.closest('.tmenu_submenu_tab_control a.tmenu_item_link, .tmenu_submenu_tab_control [role="tab"]');
  if (tabLink) {
    activateSmartMenuItem(tabLink.closest('.tmenu_item') || tabLink);
    tabLink.dispatchEvent(new MouseEvent('mouseenter', mouseOpts()));
  }

  const nested = target.closest('.tmenu_item_display_header, .tmenu_item_has_child');
  if (nested && nested !== root) activateSmartMenuItem(nested);
}

function onSmartMenuFocusOut(event) {
  const root = event.target.closest?.('.tmenu_item--root');
  if (!root || !root.hasAttribute('data-ci-kb-open')) return;
  window.requestAnimationFrame(() => {
    const active = document.activeElement;
    // Focus left the menu entirely (into the page, header icons, or the window).
    if (!root.contains(active)) closeSmartMenuKeyboard();
  });
}

function tidySmartMenuControls() {
  // The HOME GOODS 1x1 "tmenu_toggle" is an invisible Tab stop; its panel is
  // reachable from the HOME GOODS link with Space / ArrowDown instead.
  document.querySelectorAll('.tmenu_nav .tmenu_toggle').forEach((btn) => {
    if (btn.getAttribute('tabindex') !== '-1') btn.setAttribute('tabindex', '-1');
  });

  document.querySelectorAll('.tmenu_nav .tmenu_item--root').forEach((item) => {
    const link = smartMenuRootLink(item);
    if (link && smartMenuHasPanel(item) && !link.hasAttribute('aria-expanded')) {
      link.setAttribute('aria-expanded', item.hasAttribute('data-ci-kb-open') ? 'true' : 'false');
    }
  });

  // Image-only menu tiles (e.g. under RESOURCES) are href="javascript:;" with an
  // empty alt: no destination and no name. Take them out of the Tab order and
  // the accessibility tree; the text links next to them carry the destinations.
  document.querySelectorAll('.tmenu_nav a.tmenu_item_link[href^="javascript"]').forEach((a) => {
    if (a.closest('.tmenu_item--root') && a.parentElement?.classList.contains('tmenu_item--root')) return;
    if (a.getAttribute('aria-haspopup') === 'true' || a.getAttribute('role') === 'tab') return;
    const text = (a.textContent || '').replace(/\s+/g, ' ').trim();
    const named = a.getAttribute('aria-label') || Array.from(a.querySelectorAll('img')).some((img) => (img.alt || '').trim());
    if (text || named || !a.querySelector('img')) return;
    a.setAttribute('tabindex', '-1');
    a.setAttribute('aria-hidden', 'true');
  });
}

function enhanceSmartMenuKeyboard() {
  injectSmartMenuKeyboardStyles();
  tidySmartMenuControls();
  if (document.documentElement.dataset.ciSmartMenuKeyboard === 'true') return;
  document.documentElement.dataset.ciSmartMenuKeyboard = 'true';

  // a11y (2.1.2 keyboard trap): Smart Menu's own Tab handler on tab-type submenus
  // (e.g. HOME GOODS > CERAMICS) calls preventDefault() and then focuses the first
  // link it finds in the tab panel. That link sits in the hidden masonry placeholder
  // (visibility:hidden, but offsetParent != null), so focus() silently fails and
  // focus never leaves the tab. Stop the event before it reaches the app so the
  // browser's native Tab order applies: active tab -> visible panel links -> next
  // top-level item. Arrow keys between tabs are untouched (still handled by the app).
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Tab') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.tmenu_submenu_tab_control, .tmenu_submenu_tab_content')) return;
      event.stopPropagation();
    },
    true
  );

  document.addEventListener('focusin', onSmartMenuFocusIn);
  document.addEventListener('focusout', onSmartMenuFocusOut);

  // Click / tap outside an open keyboard panel closes it.
  document.addEventListener(
    'pointerdown',
    (event) => {
      const open = openSmartMenuKeyboardItem();
      if (open && !open.contains(event.target)) closeSmartMenuKeyboard();
    },
    true
  );

  // Capture phase + stopPropagation: the app has its own Enter/Space handling on
  // top items; letting both run left its internal "active" state out of sync with
  // ours (panel stayed visible after we closed it). We own these keys on desktop.
  document.addEventListener('keydown', (event) => {
    if (!isDesktopMenu()) return;

    if (event.key === 'Escape') {
      const openItem = openSmartMenuKeyboardItem() ||
        event.target.closest?.('.tmenu_item--root.tmenu_item_active');
      if (!openItem) return;
      event.preventDefault();
      const rootLink = smartMenuRootLink(openItem);
      closeSmartMenuKeyboard();
      openItem.dispatchEvent(new MouseEvent('mouseleave', mouseOpts()));
      openItem.__vueParentComponent?.exposed?.deactive?.();
      setSmartMenuExpanded(openItem, false);
      event.stopPropagation();
      rootLink?.focus();
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'ArrowDown') return;
    const link = event.target.closest?.('a.tmenu_item_link');
    if (!link) return;
    const item = link.closest('.tmenu_item--root');
    if (!item || link.parentElement !== item || !smartMenuHasPanel(item)) return;

    // Top items that are real links (HOME GOODS -> /collections/clay-casa) keep
    // Enter for navigation; Space / ArrowDown open their panel.
    const isPopupTrigger = link.getAttribute('aria-haspopup') === 'true';
    if (event.key === 'Enter' && !isPopupTrigger) return;

    event.preventDefault();
    event.stopPropagation();
    toggleSmartMenuFromKey(link, event.key);
  }, true);
}

function hideVendorDecorativeIcons() {
  document.querySelectorAll('.check-icon, .filter-menu i, .filter-group i, [class*="pt-icon"]').forEach((el) => {
    el.setAttribute('aria-hidden', 'true');
  });
}

function nameGloboFilterTriggers() {
  document
    .querySelectorAll(
      '.gf-block-title .h3[role="button"], .gf-block-title h3, [id^="filter-trigger-"], .filter-group > h4[tabindex]'
    )
    .forEach((el) => {
      const name = (el.querySelector('span')?.textContent || el.textContent || '').replace(/\s+/g, ' ').trim();
      if (name && el.getAttribute('aria-label') !== name) {
        el.setAttribute('aria-label', name);
      }
    });
}

function injectGloboIconStyles() {
  if (document.getElementById('ci-globo-icon-a11y')) return;
  const style = document.createElement('style');
  style.id = 'ci-globo-icon-a11y';
  style.textContent = `
    .gf-block-title .h3:after,
    .gf-block-title h3:after,
    .gf-option-block .gf-block-title .h3:after,
    .gf-option-block .gf-block-title h3:after {
      speak: never;
    }
  `;
  document.head.appendChild(style);
}

function walkInclusive(root, visit) {
  if (!root) return;
  visit(root);
  const tree = root.shadowRoot || root;
  if (!tree.querySelectorAll) return;
  tree.querySelectorAll('*').forEach((el) => {
    visit(el);
    if (el.shadowRoot) walkInclusive(el.shadowRoot, visit);
  });
}

function queryDeep(root, selector) {
  const matches = [];
  walkInclusive(root, (el) => {
    if (el.matches?.(selector)) matches.push(el);
  });
  return matches;
}

function findSegunoHosts() {
  const hosts = new Set(
    document.querySelectorAll(
      'seguno-popup, seguno-popups, seguno-overlay, [id*="seguno"], [class*="seguno"], [class*="sg-popup"], [class*="sg-modal"], [data-seguno]'
    )
  );
  document.querySelectorAll('*').forEach((el) => {
    if (el.tagName && el.tagName.indexOf('SEGUNO') === 0) hosts.add(el);
  });
  return Array.from(hosts);
}

function isSegunoPopupVisible(el) {
  if (!el || !el.isConnected) return false;
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 40 && rect.height > 40;
}

function deepFocusables(container) {
  const nodes = [];
  walkInclusive(container, (el) => {
    if (!el.matches) return;
    if (
      !el.matches(
        'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])'
      )
    ) {
      return;
    }
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return;
    nodes.push(el);
  });
  return nodes;
}

function nameSegunoCloseButtons(host) {
  queryDeep(host, 'button, [role="button"], a').forEach((el) => {
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    const looksClose =
      /close|dismiss|×|✕/i.test(el.getAttribute('aria-label') || '') ||
      /close|dismiss/i.test(el.className || '') ||
      text === '×' ||
      text === '✕' ||
      text === 'x' ||
      text === 'X';
    if (looksClose && !el.getAttribute('aria-label') && text.length < 3) {
      el.setAttribute('aria-label', 'Close');
    }
  });
}

function decorateSegunoDialog(host) {
  host.setAttribute('role', 'dialog');
  host.setAttribute('aria-modal', 'true');
  if (!host.hasAttribute('tabindex')) host.setAttribute('tabindex', '-1');
  host.removeAttribute('aria-hidden');
  host.removeAttribute('inert');

  const heading = queryDeep(host, 'h1, h2, h3, [class*="title"], [class*="heading"]').find(
    (el) => (el.textContent || '').trim()
  );
  if (heading) {
    if (!heading.id) heading.id = 'ci-seguno-title';
    host.setAttribute('aria-labelledby', heading.id);
  } else if (!host.getAttribute('aria-label') && !host.getAttribute('aria-labelledby')) {
    host.setAttribute('aria-label', 'Promotional offer');
  }

  queryDeep(host, 'svg, i').forEach((icon) => {
    if (!icon.getAttribute('aria-label') && !(icon.textContent || '').trim()) {
      icon.setAttribute('aria-hidden', 'true');
    }
  });

  nameSegunoCloseButtons(host);
}

let segunoOpenHost = null;

function releaseSegunoDialog() {
  if (!segunoOpenHost) return;
  if (typeof removeTrapFocus === 'function') removeTrapFocus();
  if (typeof setBackgroundInert === 'function') setBackgroundInert(segunoOpenHost, false);
  segunoOpenHost = null;
}

function openSegunoDialog(host) {
  decorateSegunoDialog(host);
  if (segunoOpenHost === host) return;

  releaseSegunoDialog();
  segunoOpenHost = host;

  if (typeof setBackgroundInert === 'function') setBackgroundInert(host, true);

  const first = deepFocusables(host)[0] || host;
  if (typeof trapFocus === 'function') {
    trapFocus(host, first);
  } else {
    first.focus?.();
  }
}

function enhanceSegunoDialogs() {
  const visible = findSegunoHosts().filter(isSegunoPopupVisible);
  if (!visible.length) {
    releaseSegunoDialog();
    return;
  }
  openSegunoDialog(visible[visible.length - 1]);
}

if (document.documentElement.dataset.ciSegunoEscape !== 'true') {
  document.documentElement.dataset.ciSegunoEscape = 'true';
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !segunoOpenHost) return;
    const close = queryDeep(segunoOpenHost, 'button, [role="button"], a').find((el) =>
      /close/i.test(el.getAttribute('aria-label') || el.className || '')
    );
    if (close) {
      event.preventDefault();
      close.click();
    }
    releaseSegunoDialog();
  });
}

function isVisibleCount(el) {
  if (!el || !el.isConnected) return false;
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function looksLikeTotalProductCount(el) {
  const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
  return /\d/.test(text) && /product/i.test(text);
}

function replaceHeadingLevel(el, level) {
  const current = Number(el.tagName[1]);
  if (!current || current === level) return el;
  const next = document.createElement(`h${level}`);
  for (const attr of el.attributes) {
    next.setAttribute(attr.name, attr.value);
  }
  while (el.firstChild) next.appendChild(el.firstChild);
  el.replaceWith(next);
  return next;
}

/**
 * Policy / CMS pages often skip heading levels in Shogun or the page RTE
 * (H1 page title → H3/H5 in body). Avada and similar scanners flag that as
 * critical 1.3.1. Normalize only inside main page content containers.
 */
function isStorefrontCmsPage() {
  if (document.body?.classList?.contains('template-page')) return true;
  if (/^\/pages\//.test(window.location.pathname || '')) return true;
  return Boolean(
    document.querySelector('#MainContent h1.main-page-title, #MainContent .main-page-title, #MainContent .page-title')
  );
}

function normalizePageContentHeadings() {
  if (!isStorefrontCmsPage()) return;

  const main =
    document.getElementById('MainContent') ||
    document.querySelector('main') ||
    document.querySelector('[role="main"]');
  if (!main) return;

  const containers = main.querySelectorAll(
    '.rte, .shg-rich-text, #shogun-root, [id^="shogun"], [data-shogun-page], .shg-box-content'
  );
  if (!containers.length) return;

  containers.forEach((container) => {
    container.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
      if (!(heading.textContent || '').replace(/\u00a0/g, ' ').trim()) {
        heading.remove();
      }
    });

    const headings = [...container.querySelectorAll('h1, h2, h3, h4, h5, h6')];
    if (!headings.length) return;

    // Theme already renders the page title as h1; body content starts at h2.
    let previousLevel = 1;
    headings.forEach((heading) => {
      let level = Number(heading.tagName[1]);
      if (level === 1) level = 2;
      if (level > previousLevel + 1) level = previousLevel + 1;
      replaceHeadingLevel(heading, level);
      previousLevel = level;
    });
  });
}

function unifyCollectionProductCounts() {
  const dawnCounts = document.querySelectorAll(
    '.product-count, .product-count-vertical, #ProductCount, #ProductCountDesktop, .mobile-facets__count'
  );
  const globoCounts = Array.from(
    document.querySelectorAll(
      '.gf-toolbar-count, .gf-summary, .gf-filter-result, .spf-toolbar [class*="count"], [class*="gf-"][class*="count"]'
    )
  ).filter((el) => looksLikeTotalProductCount(el) && isVisibleCount(el) && !el.closest('.gf-block-title, .filter-group'));

  const primaryGlobo = globoCounts[0];
  if (primaryGlobo) {
    dawnCounts.forEach((el) => {
      el.setAttribute('aria-hidden', 'true');
      el.removeAttribute('role');
      el.removeAttribute('aria-live');
    });
    globoCounts.forEach((el) => {
      if (el === primaryGlobo || primaryGlobo.contains(el) || el.contains(primaryGlobo)) return;
      el.setAttribute('aria-hidden', 'true');
      el.removeAttribute('role');
    });
    primaryGlobo.setAttribute('role', 'status');
    primaryGlobo.setAttribute('aria-live', 'polite');
    primaryGlobo.setAttribute('aria-atomic', 'true');
    primaryGlobo.removeAttribute('aria-hidden');
    return;
  }

  const primary = document.getElementById('ProductCount');
  if (primary) {
    const wrap = primary.closest('.product-count') || primary;
    wrap.setAttribute('role', 'status');
    wrap.setAttribute('aria-live', 'polite');
    wrap.setAttribute('aria-atomic', 'true');
    wrap.removeAttribute('aria-hidden');
  }

  document.querySelectorAll('#ProductCountDesktop, .product-count-vertical, .mobile-facets__count').forEach((el) => {
    if (primary && (el === primary || el.contains(primary))) return;
    el.setAttribute('aria-hidden', 'true');
    el.removeAttribute('role');
  });
}

function runVendorA11y() {
  tidySmartMenuControls();
  hideVendorDecorativeIcons();
  nameGloboFilterTriggers();
  injectGloboIconStyles();
  // enhanceSegunoDialogs(); // replaced by the M7 Seguno block at the end of this file (popup content lives in the shadow root)
  unifyCollectionProductCounts();
  normalizePageContentHeadings();
}

function watchVendorA11y() {
  if (document.documentElement.dataset.ciVendorA11y === 'true') return;
  document.documentElement.dataset.ciVendorA11y = 'true';
  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(runVendorA11y, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  fixAccessibilityButtons();
  enhanceSmartMenuKeyboard();
  runVendorA11y();
  watchVendorA11y();
});

document.addEventListener('shopify:section:load', () => {
  fixAccessibilityButtons();
  enhanceSmartMenuKeyboard();
  runVendorA11y();
});

enhanceSmartMenuKeyboard();
fixAccessibilityButtons();
runVendorA11y();
watchVendorA11y();

/* a11y M3/M4/L1: Globo filter + Globo Smart Search fixes. Idempotent; re-applied on every app re-render. */
(function () {
  if (window.__ciGloboA11y) return;
  window.__ciGloboA11y = true;

  // M3: Globo marks its decorative filter-search icon aria-hidden; never let it (or anything aria-hidden) be focusable.
  function fixFilterSearchButton() {
    document.querySelectorAll('.gf-controls-search-button[aria-hidden="true"]').forEach(function (btn) {
      btn.removeAttribute('tabindex');
      btn.removeAttribute('role');
      btn.removeAttribute('aria-label');
    });
  }

  // M3 (mobile): the closed off-canvas filter drawer (#gf-tree) is aria-hidden but its ~150 controls stayed in the tab order.
  function syncFilterDrawer() {
    var tree = document.getElementById('gf-tree');
    if (!tree) return;
    var hidden = tree.getAttribute('aria-hidden') === 'true';
    if (tree.inert !== hidden) tree.inert = hidden;
  }

  // M4: Globo Smart Search dropdown. jQuery UI wraps Globo's listbox in another <ul>, and nests a second listbox,
  // <li> wrappers and the "Search for ..." option outside the listbox. Make the outer popup the single listbox.
  function fixSearchSuggestions() {
    document.querySelectorAll('ul.ui-autocomplete.glFilter-search-popup').forEach(function (popup) {
      var inner = popup.querySelector('#gl-listbox');
      if (!inner) return;
      if (!popup.id) return;
      popup.setAttribute('role', 'listbox');
      if (!popup.getAttribute('aria-label')) popup.setAttribute('aria-label', 'Search suggestions');
      inner.setAttribute('role', 'presentation');
      popup.querySelectorAll('[role="listbox"]').forEach(function (lb) { if (lb !== popup) lb.setAttribute('role', 'group'); });
      popup.querySelectorAll('li').forEach(function (li) { if (!li.getAttribute('role') || li.getAttribute('role') === 'listitem') li.setAttribute('role', 'presentation'); });
      popup.querySelectorAll('[role="option"] a, [role="option"] button').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('input.gf-autocomplete-input[aria-controls="' + inner.id + '"]').forEach(function (input) {
        input.setAttribute('aria-controls', popup.id);
      });
      syncSelected(popup);
    });
  }

  function syncSelected(popup) {
    var input = document.querySelector('input.gf-autocomplete-input[aria-controls="' + popup.id + '"]') || document.activeElement;
    var active = input && input.getAttribute && input.getAttribute('aria-activedescendant');
    popup.querySelectorAll('[role="option"]').forEach(function (opt) {
      var sel = opt.id && opt.id === active ? 'true' : 'false';
      if (opt.getAttribute('aria-selected') !== sel) opt.setAttribute('aria-selected', sel);
    });
  }

  function run() {
    fixFilterSearchButton();
    syncFilterDrawer();
    fixSearchSuggestions();
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 50); }
  function start() {
    run();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') {
          if (r.target.id === 'gf-tree') { syncFilterDrawer(); continue; }
          if (r.attributeName === 'aria-activedescendant') {
            var popup = document.querySelector('ul.ui-autocomplete.glFilter-search-popup[role="listbox"]');
            if (popup) syncSelected(popup);
            continue;
          }
          if (r.attributeName === 'aria-selected' || r.attributeName === 'role' || r.attributeName === 'tabindex') continue;
        }
        schedule();
        return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-activedescendant', 'aria-controls'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* a11y: Globo mobile filter drawer (#gf-tree) focus management - focus in on open, Tab trapped, Esc closes,
   focus returns to "Filter By" on close. Open state = html.offcanvas-open (Globo's aria-hidden is not reliably reset on close),
   and aria-hidden is corrected to match so the closed drawer stays hidden/inert. Survives Globo re-renders. */
(function () {
  if (window.__ciGloboDrawerFocus) return;
  window.__ciGloboDrawerFocus = true;
  var opener = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

  function tree() { return document.getElementById('gf-tree'); }
  function isOpen(t) { return !!t && document.documentElement.classList.contains('offcanvas-open'); }
  function focusables(t) {
    return Array.prototype.filter.call(t.querySelectorAll(FOCUSABLE), function (el) {
      if (el.closest('[inert], [aria-hidden="true"]') && el.closest('[aria-hidden="true"]') !== null && t.contains(el.closest('[aria-hidden="true"]'))) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function offCanvasMode() {
    var m = document.querySelector('.gf-refine-toggle-mobile');
    return !!m && m.getClientRects().length > 0 && getComputedStyle(m).display !== 'none';
  }
  function closeBtn(t) { return t.querySelector('.gf-close-canvas'); }

  function onOpen(t) {
    var a = document.activeElement;
    if (a && !t.contains(a) && a !== document.body) opener = a;
    if (!opener) opener = document.querySelector('.gf-refine-toggle-mobile button');
    setTimeout(function () {
      if (!isOpen(t) || t.contains(document.activeElement)) return;
      var target = closeBtn(t) || focusables(t)[0];
      if (target) target.focus();
    }, 50);
  }
  function onClose(t) {
    var a = document.activeElement;
    var back = opener && opener.isConnected ? opener : document.querySelector('.gf-refine-toggle-mobile button');
    opener = null;
    if (back && (!a || a === document.body || t.contains(a))) back.focus();
  }

  var lastState = null;
  function check() {
    var t = tree();
    var open = isOpen(t);
    if (t && !offCanvasMode()) {
      // Desktop: #gf-tree is the inline sidebar, not a drawer - leave it alone (undo anything we set).
      if (t.dataset.ciDrawerManaged) { t.removeAttribute('aria-hidden'); t.inert = false; delete t.dataset.ciDrawerManaged; }
      lastState = null;
      return;
    }
    if (t) {
      t.dataset.ciDrawerManaged = '1';
      var want = open ? 'false' : 'true';
      if (t.getAttribute('aria-hidden') !== want) t.setAttribute('aria-hidden', want);
      if (t.inert === open) t.inert = !open;
    }
    if (open === lastState) return;
    lastState = open;
    if (!t) return;
    if (open) onOpen(t); else onClose(t);
  }

  document.addEventListener('keydown', function (e) {
    var t = tree();
    if (!isOpen(t) || !offCanvasMode()) return;
    if (e.key === 'Escape') {
      var c = closeBtn(t);
      if (c) { e.preventDefault(); c.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(t);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!t.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }, true);

  function start() {
    lastState = null;
    check();
    window.addEventListener('resize', function () { setTimeout(check, 100); });
    new MutationObserver(check).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* a11y M7: Seguno sign-up popup. Seguno renders its own role=dialog (aria-modal, focused on open) inside the
   seguno-popup shadow root (opened by the attachShadow shim in layout/theme.liquid). Here we: give the dialog a real
   name, keep Tab inside it, take the invisible hCaptcha iframe out of the Tab order, and put focus back where the
   shopper was when it closes. Visuals and popup timing are untouched. Re-applied on every Seguno re-render. */
(function () {
  if (window.__ciSegunoA11y) return;
  window.__ciSegunoA11y = true;
  var DIALOG_NAME = 'Sign up and save';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex^="-"])';
  var lastOutside = null;
  var wasOpen = false;

  function hosts() {
    return Array.prototype.filter.call(document.querySelectorAll('*'), function (el) {
      return el.tagName && el.tagName.indexOf('SEGUNO') === 0 && el.shadowRoot;
    });
  }
  function visible(el) {
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    var s = getComputedStyle(el);
    return s.visibility !== 'hidden' && s.display !== 'none' && s.opacity !== '0';
  }
  function openDialog() {
    var hs = hosts();
    for (var i = 0; i < hs.length; i++) {
      var d = hs[i].shadowRoot.querySelector('[role="dialog"]');
      if (d && visible(d)) return d;
    }
    return null;
  }
  function deepActive() {
    var a = document.activeElement;
    while (a && a.shadowRoot && a.shadowRoot.activeElement) a = a.shadowRoot.activeElement;
    return a;
  }
  function focusables(d) {
    return Array.prototype.filter.call(d.querySelectorAll(FOCUSABLE), function (el) {
      if (!visible(el)) return false;
      if (el.tagName === 'IFRAME' || el.tagName === 'TEXTAREA') {
        var r = el.getBoundingClientRect();
        if (r.width < 10 || r.height < 10) return false;
      }
      return true;
    });
  }
  function decorate(d) {
    var label = d.getAttribute('aria-label');
    if (!label || /^popup$/i.test(label)) d.setAttribute('aria-label', DIALOG_NAME);
    d.setAttribute('aria-modal', 'true');
    // invisible hCaptcha iframe / response textarea should not be Tab stops
    d.querySelectorAll('iframe, textarea[id^="h-captcha-response"]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 10 || r.height < 10) el.setAttribute('tabindex', '-1');
    });
    d.querySelectorAll('button').forEach(function (b) {
      if (!b.getAttribute('aria-label') && !(b.textContent || '').trim()) b.setAttribute('aria-label', 'Close');
    });
  }
  function check() {
    var d = openDialog();
    if (d) {
      decorate(d);
      wasOpen = true;
    } else if (wasOpen) {
      wasOpen = false;
      var a = deepActive();
      var lost = !a || a === document.body || a === document.documentElement || (a.getRootNode && a.getRootNode() !== document) || (a.tagName && a.tagName.indexOf('SEGUNO') === 0);
      if (lost && lastOutside && lastOutside.isConnected) lastOutside.focus({ preventScroll: true });
    }
  }

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.tagName && t.tagName.indexOf('SEGUNO') !== 0 && t !== document.body) lastOutside = t;
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = openDialog();
    if (!d) return;
    var f = focusables(d);
    if (!f.length) return;
    var a = deepActive();
    var first = f[0], last = f[f.length - 1];
    if (!d.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && (a === first || a === d)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }, true);

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 60); }
  var observed = new WeakSet();
  function observe(root) {
    if (observed.has(root)) return;
    observed.add(root);
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'role', 'aria-label'] });
  }
  function start() {
    observe(document.body);
    setInterval(function () { hosts().forEach(function (h) { observe(h.shadowRoot); observe(h); }); check(); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Product gallery: keep inactive/off-screen "Open media N in modal" toggles out of Tab order.
   Sense hover-zoom renders one toggle per image; on mobile they are focusable even when 0x0 / off-screen. */
(function () {
  var TOGGLE = 'button.product__media-toggle';
  var ITEM = '.product__media-item';

  function sync() {
    var items = document.querySelectorAll(ITEM);
    var hasActive = false;
    items.forEach(function (item) {
      if (item.classList.contains('is-active') && item.getAttribute('aria-hidden') !== 'true') hasActive = true;
    });
    items.forEach(function (item, index) {
      var active = item.classList.contains('is-active');
      var ariaHidden = item.getAttribute('aria-hidden') === 'true';
      var enable = (!hasActive ? index === 0 : active) && !ariaHidden;
      item.querySelectorAll(TOGGLE).forEach(function (btn) {
        // Skip when CSS already removes from a11y tree (desktop hover zoom = display:none)
        var cs = window.getComputedStyle(btn);
        if (cs.display === 'none' || cs.visibility === 'hidden') {
          if (btn.hasAttribute('tabindex')) btn.removeAttribute('tabindex');
          return;
        }
        if (enable) {
          if (btn.getAttribute('tabindex') === '-1') btn.removeAttribute('tabindex');
        } else if (btn.getAttribute('tabindex') !== '-1') {
          btn.setAttribute('tabindex', '-1');
        }
      });
    });
  }

  function start() {
    sync();
    var root = document.querySelector('media-gallery, .product__media-wrapper, .product__media-list');
    if (root) {
      new MutationObserver(function () { sync(); }).observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    }
    document.addEventListener('shopify:section:load', sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Sitewide: accessible names for Qikify Smart Menu links (Vue may remount
   markup; derive aria-label from .tmenu_item_text / img alt / visually-hidden
   when the link would otherwise have an empty accessible name). Also label
   social icon links that only expose a .visually-hidden span. */
(function () {
  function derivedName(el) {
    if (!el) return '';
    var span = el.querySelector('.tmenu_item_text');
    if (span && span.textContent) {
      var t = span.textContent.replace(/\s+/g, ' ').trim();
      if (t) return t;
    }
    var img = el.querySelector('img');
    if (img) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (alt) return alt;
    }
    var vh = el.querySelector('.visually-hidden, .sr-only');
    if (vh && vh.textContent) {
      var v = vh.textContent.replace(/\s+/g, ' ').trim();
      if (v) return v;
    }
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function labelLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a.tmenu_item_link').forEach(function (a) {
      if ((a.getAttribute('aria-label') || '').trim()) return;
      if ((a.getAttribute('aria-labelledby') || '').trim()) return;
      // Prefer native name from laid-out text when present
      var inner = (a.innerText || '').replace(/\s+/g, ' ').trim();
      if (inner) return;
      var name = derivedName(a);
      if (!name) return;
      a.setAttribute('aria-label', name);
      a.setAttribute('data-ci-a11y-named', '1');
    });
    scope.querySelectorAll('a.list-social__link').forEach(function (a) {
      if ((a.getAttribute('aria-label') || '').trim()) return;
      var name = derivedName(a);
      if (name) a.setAttribute('aria-label', name);
    });
  }

  function start() {
    labelLinks(document);
    var timer;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () { labelLinks(document); }, 80);
    }
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    setInterval(function () { labelLinks(document); }, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Sitewide: Shopify web-pixels iframe is a tiny hidden tracker. Give it a
   title for frame-title / custom audits, and keep it out of the a11y tree. */
(function () {
  function fixPixels(root) {
    (root || document).querySelectorAll('iframe').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (src.indexOf('web-pixels') === -1 && src.indexOf('/web-pixel') === -1) return;
      if (!(f.getAttribute('title') || '').trim()) {
        f.setAttribute('title', 'Shopify web pixel');
      }
      f.setAttribute('aria-hidden', 'true');
      f.tabIndex = -1;
    });
  }
  function start() {
    fixPixels(document);
    new MutationObserver(function () { fixPixels(document); }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();